import { render, staticRenderFns } from "./EditCheckZonaVincoloDialog.vue?vue&type=template&id=56d0382d&scoped=true"
import script from "./EditCheckZonaVincoloDialog.vue?vue&type=script&lang=ts"
export * from "./EditCheckZonaVincoloDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d0382d",
  null
  
)

export default component.exports